import React from 'react';
import './style.scss';

const Pagination = ({ pagination: { lastPage, page, pageSize, totalCount }, updatePagination }) => {
    const handlePagination = (direction) => {
        let moveBy = direction === 'next' ? 1 : -1;
        let newIndex = page + moveBy;

        if (newIndex > 0 && newIndex <= lastPage) {
            updatePagination(newIndex);
        }
    };

    const currentItem = page > 1 ? 1 + pageSize * (page - 1) : 1;
    const pageTotal = (totalCount < pageSize || totalCount < page * pageSize
        ? totalCount
        : page * pageSize
    );

    return (
        <div className="cbdce-education-finder__pagination">
            <button
                className="cbdce-button btn btn-dark"
                disabled={!(page > 1)}
                onClick={() => handlePagination('prev')}
            >
                <i className="fa-solid fa-arrow-left"></i>
                <span className="cbdce-button__label">Previous</span>
            </button>
            <div className="cbdce-education-finder__pagination-msg">
                Showing {currentItem} to {pageTotal} of {totalCount} results
            </div>

            <button
                className="cbdce-button btn btn-dark"
                disabled={!(page < lastPage)}
                onClick={(e) => handlePagination('next')}
            >
                <span className="cbdce-button__label">Next</span>
                <i className="fa-solid fa-arrow-right"></i>
            </button>
        </div>
    );
};

export default Pagination;
